import { Buffer } from 'buffer';
window.Buffer = Buffer;

// import { createRoot } from 'react-dom/client';
// import './index.css';
// import App from './App.jsx';
// import React from 'react';
// import { Provider } from "react-redux";
// import { PersistGate } from 'redux-persist/integration/react';
// import CssBaseline from '@mui/material/CssBaseline';
// import { BrowserRouter as Router } from "react-router-dom";
// import { store, persistor } from "./store/store"; // Import both store and persistor

// console.log("App is reloading...''''''''''''''''''");

// createRoot(document.getElementById('root')).render(
//   <Provider store={store}>
//     <PersistGate loading={null} persistor={persistor}>
//       <Router>
//         <CssBaseline />
//         <App />
//       </Router>
//     </PersistGate>
//   </Provider>
// );


import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.jsx'
// import './App.css'
import React, { StrictMode } from 'react'
import { Provider } from "react-redux";
import CssBaseline from '@mui/material/CssBaseline';
import { BrowserRouter } from "react-router-dom";
import store from "./store/store";

import { BrowserRouter as Router, Routes, Route, Navigate, useNavigate } from "react-router-dom";

createRoot(document.getElementById('root')).render(
<>
     {/* <CssBaseline /> */}
   <Provider store={store}>  {/* ✅ Wrap your app in Provider */}
   <Router>
  
    {/* <ChatIcon/> */}
   <App/>
   </Router>
  </Provider>
   
  </>,
)
